import axios from "axios";
import authHeader from "../../api/services/token.interceptor";

const API_URL = process.env.REACT_APP_API_URL;

const JSON_HEADERS = { "Content-Type": "application/json" };

export const login = async (payload: any) =>
    await axios.post(`${API_URL}/recouv/api-token-auth`, payload, {
        headers: JSON_HEADERS,
    })

export const register = async (payload: any) =>
    await axios.post(`${API_URL}/recouv/users/`, payload, {
        headers: JSON_HEADERS,
    })

export const registerCompany = async (payload: any) =>
    await axios.post(`${API_URL}/formalite/user_demandeur/create_user_and_demandeur_together/`, payload, {
        headers: JSON_HEADERS,
    })

export const verificationOtp = async (payload: any) =>
    await axios.post(`${API_URL}/recouv/activate-account`, payload, {
        headers: authHeader(),
    })

export const forgotPassword = async (payload: any) =>
    await axios.post(`${API_URL}/recouv/password-reset`, payload, {
        headers: authHeader(),
    })

export const resetPassword = async (payload: any) =>
    await axios.post(`${API_URL}/recouv/password-reset-confirm`, payload, {
        headers: authHeader(),
    })
